import { motion } from "framer-motion";

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="border-y border-hairline bg-[color:var(--bg)]"
    >
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 py-6 md:py-8 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <motion.p
          initial={{ opacity: 0, y: 8 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-20% 0px" }}
          transition={{ duration: 0.6 }}
          className="mono-label !text-white/80"
        >
          Trusted for CRM, eCommerce & API engineering since 2012
        </motion.p>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mono-label">
          <span>Stripe</span><span className="text-white/25">/</span>
          <span>PayPal</span><span className="text-white/25">/</span>
          <span>Authorize.net</span><span className="text-white/25">/</span>
          <span>NMI</span><span className="text-white/25">/</span>
          <span>AWS</span><span className="text-white/25">/</span>
          <span>Zapier</span>
        </div>
      </div>
    </section>
  );
}
